export const R = {
	"YourNextConsultation": "Din næste konsultation",
	"GoToUpcomingConsultation": "Se aftalen",
	"BackToBookingButtonLabel": "Tilbage til booking",
	"SundvaegtGoalCardTitle": "Din vægtlog",
	"SundvaegtGoalCardDescription": "For nogen kan det være en motivation at veje sig. Hvis det styrker din motivation, kan du følge din fremgang ved at logge din vægt løbende.",
	"SundvaegtGoalCardActionButtonText": "Sæt dig et mål",
	"SundvaegtGoalProgressStartLabel": "Start",
	"SundvaegtGoalProgressEndLabel": "Mål",
	"SundvaegtGoalProgressWeightLabel": "Vægt",
	"SundvaegtSetWeightGoalModalTitle": "Sæt dig et mål",
	"SundvaegtSetWeightGoalModalDescription": "Ved at logge din vægt løbende kan du følge din fremgang. Det kan være en hjælp til at nå dit mål.",
	"SundvaegtSetWeightGoalModalInputLabel": "Din ønskede målvægt",
	"SundvaegtSetWeightGoalModalInputRequiredLabel": "Du mangler at udfylde din målvægt.",
	"SundvaegtSetWeightGoalModalSubmitButton": "Gem målvægt",
	"SundvaegtSetWeightGoalModalInfoTitle": "Din målvægt er for lav",
	"SundvaegtSetWeightGoalModalInfoDescription": "I forhold til din højde anbefaler vi en vægt over {0} kg. Det svarer til et BMI på 18,5 eller derover.",
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooHigh": "Din målvægt skal være lavere end din startvægt.",
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooLow": "Indtast en målvægt over {0} kg.",
	"SundvaegtSetWeightGoalErrorMessage": "Kunne ikke gemme vægtmål:",
	"SundvaegtAddWeightLogErrorMessage": "Kunne ikke gemme vægtlog:",
	"SundvaegtEditWeightLogErrorMessage": "Kunne ikke opdatere vægtlog:",
	"SundvaegtDeleteWeightLogErrorMessage": "Kunne ikke slette vægtlog:",
	"SundvaegtSetWeightGoalInputPlaceholder": "Indtast målvægt",
	"SundvaegtProgramConfirmationLabel": "Nu er du i gang med dit vægttab!",
	"SundvaegtProgramLogWeightButtonLabel": "Log vægt",
	"SundvaegtAddWeightLogModalTitle": "Log vægt",
	"SundvaegtAddWeightLogModalInputLabel": "Vægt",
	"SundvaegtAddWeightLogModalInputRequiredLabel": "Du mangler at udfylde vægt.",
	"SundvaegtAddWeightLogModalSubmitButton": "Gem vægt",
	"SundvaegtAddWeightLogInputPlaceholder": "Indtast vægt",
	"SundvaegtWeightLogCardLatestWeightLossLabel": "Vægttab siden sidst:",
	"SundvaegtWeightLogCardOverallWeightLossLabel": "Samlet vægttab:",
	"SundvaegtWeightLogCardOverallWeightLossStatus": "Du har tabt {0} ud af {1}",
	"SundvaegtWeightLogCardOverallWeightLossStatusPart1": "Du har tabt",
	"SundvaegtWeightLogCardOverallWeightLossStatusPart2": "ud af",
	"SundvaegtWeightEditWeightLogLabel": "Ret vægtlog",
	"SundvaegtWeightDeleteWeightLogLabel": "Slet vægtlog",
	"SundvaegtDateInputLabel": "Dato",
	"SundvaegtDateInputRequiredLabel": "Du mangler at udfylde dato.",
	"SundvaegtPleaseEnterValidWeightLabel": "Indtast venligst en gyldig vægt.",
	"SundvaegtWeightLogChartYLabel": "Vægt (kg)",
	"SundvaegtWeightLogChartXLabel": "Måned",
	"SundVaegtChartTooltip": "Dato: {0}, Vægt: {1}",
	"NnSundvaegtConsultationsLeft": "Du har {0} gratis videokonsultationer",
	"NnSundvaegtConsultationsExpire": "Dine gratis konsultationer udløber:",
	"NnSundvaegtAreYouDone": "Har du nået dit vægtmål eller er du stoppet på Wegovy? Her kan du ",
	"NnSundvaegtCancelProgram": "afmelde dig SundVægt Sammen.",
	"SundvaegtFeedbackTitle": "Hjælp os med at blive bedre",
	"SundvaegtFeedbackDescription": "Vi vil meget gerne høre om din oplevelse med SundVægt. Besvar tre korte spørgsmål og hjælp os med at forstå, hvad der fungerer godt, og hvor vi kan blive bedre.",
	"SundvaegtFeedbackButtonLabel": "Besvar spørgsmål",
	"EditGoalWeight": "Rediger målvægt",
	"ArticlesHeader": "Udvalgte artikler",
	"ShowMore": "Vis mere",
	"ShowLess": "Vis mindre",
	"All": "Alle",
	"MeetTheTeamHeader": "Mød teamet",
	"ArticleNewLabel": "Ny"
}